import {createPortError} from '../platform/port-error.js';
import {createCatalogueProduct} from './product-catalogue.js';

function requireClient(client){
  if(typeof client?.from!=='function')throw new TypeError('Database client with from() is required');
  return client;
}

function fromRow(row={}){
  return createCatalogueProduct({
    code:row.code,
    categoryKey:row.category_key,
    displayNamePl:row.display_name_pl,
    displayNameEn:row.display_name_en,
    sortOrder:row.sort_order,
    catalogueVersion:row.catalogue_version
  });
}

export function createSupabaseProductCatalogueRemote({client}={}){
  const db=requireClient(client);
  async function list(){
    const {data,error}=await db
      .from('product_catalogue')
      .select('code,category_key,display_name_pl,display_name_en,sort_order,catalogue_version,is_active')
      .eq('is_active',true)
      .order('sort_order',{ascending:true});
    if(error)throw createPortError('CATALOGUE_REMOTE_UNAVAILABLE',{retryable:true});
    return Object.freeze((data||[]).filter(row=>row?.is_active!==false).map(fromRow));
  }
  return Object.freeze({list});
}
